export default "__VITE_ASSET__IQYmdE0o__"